import React from 'react';

//dropdown CIUDADES => solo ciudades del departamento seleccionado
const DetDetalleSelCi = props => {
  return (
    <option dato1={props.elemento.codigoCiudad} dato2={props.elemento.codigoCiudadInterno?props.elemento.codigoCiudadInterno:""} dato3={props.elemento.codBarrasRdo?props.elemento.codBarrasRdo:""} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
  )
};

const ListaCi = ({styles, handleLista1, list, esUpd, argsDocum, idLista, permiteUpdate}) => {
  // console.log(list, argsDocum, idLista, esUpd)
// const Lista = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
  if(esUpd){
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista1" value={permiteUpdate?argsDocum.codigoCiudad:idLista.codigoCiudad} onChange={(ev)=>handleLista1(ev, argsDocum)}>
          {Nivel1Detalle}
        </select>
      </div>
    )
  }else{
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista1" onChange={handleLista1}>
          {Nivel1Detalle}
        </select>
      </div>
    )
  }
};
//Fin dropdown CIUDADES

export default ListaCi